"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _materialReactTable = require("material-react-table");
var _Error = require("./Error");
var _mui_style_overrides = require("./mui_style_overrides");
var _no_adapprovals = _interopRequireDefault(require("./assets/no_adapprovals.png"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BasicTable = _ref => {
  let {
    table_data,
    table_columns,
    renderTopToolbarCustomActions,
    renderHelpText,
    ...rest
  } = _ref;
  const columns = (0, _react.useMemo)(() => table_columns, [table_columns]);
  const data = (0, _react.useMemo)(() => table_data, [table_data]);
  return /*#__PURE__*/_react.default.createElement(_materialReactTable.MaterialReactTable, (0, _extends2.default)({
    columns: columns,
    data: data,
    enableRowSelection: false,
    enableColumnFilters: false,
    enableFullScreenToggle: true,
    enableDensityToggle: true,
    positionGlobalFilter: "left",
    positionActionsColumn: rest.positionOfActionsColumn,
    paginationDisplayMode: "pages",
    enableToolbarInternalActions: false,
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: rest.actionColumnName,
        //customize action column style
        Header: rest.customizeActionColumnJSX,
        enablePinning: true,
        enableColumnActions: true
      }
    },
    renderRowActions: tableDetails => rest.renderTableRowActions(tableDetails),
    getRowId: row => row?.id,
    initialState: {
      showGlobalFilter: true,
      ...rest.initialStateOptions
    },
    muiSearchTextFieldProps: {
      variant: "outlined",
      size: "small",
      helperText: rest.seachHelperText || "",
      sx: {
        width: "18.5rem"
      }
    },
    state: {
      ...rest.state
    },
    renderEmptyRowsFallback: () => rest.isError ? /*#__PURE__*/_react.default.createElement(_Error.TableError, {
      title: rest.errorApiFailed?.title ?? "API Failed.",
      description: rest.errorApiFailed?.description ?? "Please try again after some time"
    }) : /*#__PURE__*/_react.default.createElement(_Error.TableError, {
      title: rest.errorNoResult?.title ?? "No search results found",
      imgUrl: rest.errorNoResult?.imgUrl ?? _no_adapprovals.default,
      description: rest.errorNoResult?.description ?? ""
    }),
    renderTopToolbarCustomActions: table => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "table__left--content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table__total--result"
      }, data.length, " results"), renderHelpText ? /*#__PURE__*/_react.default.createElement("div", {
        className: "table__help--text"
      }, renderHelpText) : null), renderTopToolbarCustomActions && renderTopToolbarCustomActions({
        table: table
      }));
    }
  }, _mui_style_overrides.styles, rest));
};
BasicTable.defaultProps = {
  enableTableFooter: false,
  renderHelpText: ""
};
BasicTable.propTypes = {
  enableTableFooter: _propTypes.default.bool,
  renderHelpText: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.node])
};
var _default = exports.default = BasicTable;